{
	"promo": {
		"title": "You've got Pro for 12 months",
		"subtitle": "Free for the duration of the promo — all StudyHub features with no limits.",
		"perks": {
			"unlimited": "Unlimited notes, flashcards and quizzes",
			"ai": "All AI modes and the voice tutor",
			"recordings": "Lecture recording and audio recaps with no limits",
			"priority": "Priority processing"
		},
		"footnote": "When the promo ends your plan reverts to Free — your data is kept.",
		"cta": "Great"
	},
	"title": "Subscription",
	"currentPlan": "Current plan",
	"tiers": {
		"free": "Free",
		"freeDescription": "Basic features to get started",
		"plus": "Plus",
		"plusDescription": "Extended limits and AI modes",
		"pro": "Pro",
		"proDescription": "Maximum capabilities and priority"
	},
	"pricing": {
		"perMonth": "{price} / month",
		"perYear": "{price} / year",
		"monthShort": "mo",
		"yearShort": "yr",
		"save": "Save {percent}%",
		"trial": "{days}-day trial",
		"monthly": "Monthly",
		"annual": "Annual"
	},
	"upgrade": {
		"cta": "Upgrade to {tier}",
		"ctaShort": "Upgrade",
		"title": "Unlock more",
		"subtitle": "Get more AI operations and advanced features",
		"recommended": "Recommended",
		"perks": {
			"plus": {
				"a": "Higher limits on notes, flashcards and quizzes",
				"b": "Lecture recording and audio recaps",
				"c": "Voice tutor and essay grading"
			},
			"pro": {
				"a": "Unlimited notes, flashcards and quizzes",
				"b": "Every AI mode with priority processing",
				"c": "Longer recordings and unlimited audio recaps"
			}
		}
	},
	"paywall": {
		"quotaReached": "You've hit your plan limit",
		"featureLocked": "This feature is available on {tier}",
		"upgrade": "Upgrade",
		"later": "Later",
		"triggers": {
			"quota_exceeded": "Limit reached",
			"pro_only_feature": "Pro-only feature",
			"recording_limit": "Recording limit",
			"storage_limit": "Storage limit",
			"voice_tutor_locked": "Voice tutor — Plus or Pro",
			"audio_recap_locked": "Audio recap — Plus or Pro",
			"trial_ending": "Your trial is ending soon",
			"manual": "Upgrade your plan"
		},
		"feature": {
			"audio-recap": {
				"title": "Audio recap is available on Plus",
				"description": "Turn your materials into podcasts, lectures, audiobooks and short recaps — with multiple delivery styles and voices.",
				"bullets": [
					"4 formats: podcast, lecture, audiobook, summary",
					"18 style directions to choose from",
					"Custom wishes — tune it to your needs"
				],
				"cta": "Upgrade to Plus"
			}
		}
	},
	"cancel": {
		"action": "Cancel subscription",
		"confirmTitle": "Cancel subscription?",
		"confirmDescription": "You'll keep access to {tier} features until {date}.",
		"confirm": "Cancel",
		"keep": "Keep",
		"reasonLabel": "Why are you cancelling?",
		"reasons": {
			"too_expensive": "Too expensive",
			"not_useful": "Didn't find use for it",
			"missing_features": "Missing features",
			"found_alternative": "Found an alternative",
			"other": "Other"
		},
		"feedback": "Comment (optional)"
	},
	"history": {
		"title": "Payment history",
		"empty": "No payments yet",
		"invoice": "Invoice",
		"paid": "Paid",
		"refunded": "Refunded",
		"failed": "Failed"
	},
	"paymentMethod": {
		"title": "Payment method",
		"yookassa": "YooKassa",
		"paypal": "PayPal",
		"card": "Card",
		"update": "Update payment method",
		"infoYookassa": "Payment is handled by YooKassa. We don't store card details.",
		"infoPaypal": "Payment is handled by PayPal. We don't store card details."
	},
	"checkout": {
		"processing": "Creating payment session…",
		"cancel": "Close",
		"errorTitle": "Couldn't create session"
	},
	"refund": {
		"statusTitle": "Refund request",
		"status": {
			"pending": "Under review",
			"auto_approved": "Auto-approved",
			"approved": "Approved",
			"rejected": "Rejected",
			"processed": "Refunded to account"
		},
		"submittedAt": "Submitted {date}",
		"reasonLabel": "Reason",
		"reasons": {
			"ai_generation_failed": "AI generation failed",
			"service_outage": "Service outage",
			"other": "Other"
		},
		"timelineTitle": "Timeline",
		"timeline": {
			"submitted": "Request submitted",
			"reviewing": "Under review",
			"decision": "Decision made",
			"money_back": "Refund completed"
		},
		"supportCta": "Contact support",
		"backCta": "Back to payment history",
		"notFound": "Refund request not found"
	},
	"manage": {
		"title": "Manage subscription",
		"subtitle": "Change plan, payment method, or cancel",
		"sections": {
			"changePlan": "Change plan",
			"updatePayment": "Payment method",
			"cancel": "Cancel subscription"
		},
		"changePlanCta": "Choose plan",
		"changePlanHint": "Switch to a different plan or change the billing cycle.",
		"updatePaymentCta": "Update",
		"updatePaymentHint": "Opens the provider page to update your card or payment method.",
		"cancelCta": "Cancel"
	},
	"pastDue": {
		"title": "Payment failed",
		"subtitle": "Update your payment method to keep access.",
		"daysLeft": "{count, plural, one {# day} other {# days}} until downgrade to Free",
		"updateCta": "Update payment",
		"dismiss": "Dismiss"
	},
	"trial": {
		"daysLeft": "{count, plural, one {# day left} other {# days left}}",
		"dismiss": "Dismiss"
	},
	"iec": {
		"portalFailed": "Couldn't open your IEC ID account. Opening the plain link instead.",
		"checkoutFailed": "Couldn't open checkout. Please try again.",
		"trialUnavailable": "A free trial isn't available for your account.",
		"planLabel": "{tier} plan",
		"expiresOn": "Active until {date}",
		"renewWarning": "Renew before {date} or access ends",
		"includedInPlusHint": "{tier} comes with your IEC+ subscription — a separate StudyHub plan isn't needed.",
		"localSubscriptionHint": "You have an active StudyHub subscription — manage it here.",
		"manageCta": "Manage IEC+",
		"manageLocalCta": "Manage StudyHub plan",
		"viewAllPlans": "All plans",
		"source": {
			"subscription": "Subscription",
			"trial": "Trial",
			"gift": "Gift",
			"grant": "Granted",
			"other": "Ecosystem access"
		},
		"trial": {
			"offerTitle": "Try {tier} free",
			"offerBody": "{count, plural, one {# day} other {# days}} of full access. No card required — pay only if you decide to.",
			"offerCta": "Start free trial",
			"bannerTitle": "{tier} trial",
			"bannerSubtitle": "When the trial ends you go back to the free plan — nothing is charged.",
			"bannerCta": "Get a subscription"
		},
		"return": {
			"pendingTitle": "Checking your payment",
			"pendingBody": "Access usually appears within a minute.",
			"confirmedTitle": "Access unlocked",
			"confirmedBody": "Payment confirmed — your new level is already active.",
			"confirmedCta": "Continue",
			"timeoutTitle": "Payment is still processing",
			"timeoutBody": "Confirmation hasn't arrived yet. Access turns on by itself — open this page again a bit later.",
			"timeoutCta": "Got it"
		}
	},
	"noSale": {
		"quotaReached": "You've reached the limit for this action",
		"featureUnavailable": "This feature isn't available right now",
		"lockedTitle": "Not available yet",
		"lockedDescription": "This feature isn't open in the app yet."
	}
}
